import {
  DndContext,
  useSensor,
  useSensors,
  MouseSensor,
  TouchSensor,
} from "@dnd-kit/core";
import React, { useEffect, useRef, useState } from "react";
import MakeBusyOrFreeTable from "./ReservationTablesSubComponents/MakeBusyOrFreeTable";

import { useSelector } from "react-redux";

import ResizeObserver from "resize-observer-polyfill";

import { Draggable } from "./ReservationTablesSubComponents/Draggable";
import { Droppable } from "./ReservationTablesSubComponents/Droppable";
import "./index.css";

const VIRTUAL_WIDTH = 1300;
const VIRTUAL_HEIGHT = 650;

const ReservationTables = ({ backgroundImage }) => {
  const [clickedTable, setClickedTable] = useState();
  const { tables } = useSelector((state) => state.restaurantSchemaReducer);

  const containerRef = useRef(null);
  const [containerSize, setContainerSize] = useState({
    width: VIRTUAL_WIDTH,
    height: VIRTUAL_HEIGHT,
  });

  useEffect(() => {
    const handleResize = (entries) => {
      for (let entry of entries) {
        if (entry.target === containerRef.current) {
          const { width, height } = entry.contentRect;
          setContainerSize({ width, height });
        }
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);

    const currentContainer = containerRef.current;
    if (currentContainer) {
      resizeObserver.observe(currentContainer);
    }

    return () => {
      if (currentContainer) {
        resizeObserver.unobserve(currentContainer);
      }
    };
  }, []);

  const scaleFactor = Math.min(
    containerSize.width / VIRTUAL_WIDTH,
    containerSize.height / VIRTUAL_HEIGHT
  );

  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 200,
        tolerance: 6,
      },
    })
  );

  const onTableClick = (id) => {
    setClickedTable(tables.filter((table) => table.id === id));
  };

  return (
    <>
      <MakeBusyOrFreeTable
        clickedTable={clickedTable}
        setClickedTable={setClickedTable}
      />
      <div className="reservations-schema-content-container">
        <DndContext sensors={sensors}>
          <Droppable ref={containerRef} backgroundImage={backgroundImage}>
            {tables?.map((table) => (
              <Draggable
                key={table.id}
                id={table.id}
                tableName={table.tableName}
                position={{
                  x: table.x * scaleFactor,
                  y: table.y * scaleFactor,
                }}
                direction={table.direction}
                shape={table.shape}
                seatsCount={table.seatsCount}
                scale={table.scale || 1.0}
                scaleFactor={scaleFactor}
                nextReservation={table.nextReservation}
                isBusy={table.busy}
                tableOpenDurationInMinutes={table.tableOpenDurationInMinutes}
                onTableClick={onTableClick}
              />
            ))}
          </Droppable>
        </DndContext>
      </div>
      <div className="reservations-schema-legend">
        <div className="reservations-schema-legend-item">
          <div className="reservations-schema-legend-dot free" />
          Свободна
        </div>
        <div className="reservations-schema-legend-item">
          <div className="reservations-schema-legend-dot busy" />
          Заета
        </div>
        <div className="reservations-schema-legend-item">
          <div className="reservations-schema-legend-dot reserved" />
          Резервирана
        </div>
      </div>
    </>
  );
};

export default ReservationTables;
